import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import {
    NUMBER, SCIENTIFIC, FIT,
    MTTF_HOURS, MTTF_YEARS, MTTF_1_YEAR_HOURS,
    DECIMAL, PERCENT,
    FIT_RATIO,
} from "const"
import {
    SilFailureRateFormat,
    SilProbabilityFormat,
    SilPercentageFormat,
} from "client/utils"
import { StoreType } from "client/store"


const ExampleWrapper = styled.div`
    display: flex;
    height: 33px;
    align-items: center;
`

interface DecimalExampleProps {
    format: SilFailureRateFormat | SilProbabilityFormat | SilPercentageFormat
    decimal: number
}

const DecimalExample = ({
    format,
    decimal,
}: DecimalExampleProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const value = 0.12345678910
    let formattedValue = ""
    switch (format) {
        case NUMBER:
        case DECIMAL:
            formattedValue = value.toFixed(decimal)
            break

        case SCIENTIFIC:
            formattedValue = value.toExponential(decimal)
            break

        case FIT:
            formattedValue = lang.fitX.replace("{0}", (value * FIT_RATIO).toFixed(decimal))
            break

        case MTTF_HOURS:
            formattedValue = lang.mttfXHours.replace("{0}", (1 / value).toFixed(decimal))
            break

        case MTTF_YEARS:
            formattedValue = lang.mttfXYears.replace("{0}", (1 / value / MTTF_1_YEAR_HOURS).toFixed(decimal))
            break

        case PERCENT:
            formattedValue = `${(value * 100).toFixed(decimal)} %`
            break

        default:
            break
    }

    return <ExampleWrapper>{`e.g.: ${formattedValue}`}</ExampleWrapper>
}
export default DecimalExample
